import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useApply } from "./ApplyContext";

/**
 * Vertical floating button anchored to the right side of the viewport.
 * Clicking opens the slide-in admission drawer.
 * Stays above bottom-nav on mobile.
 */
export default function ApplyFloatingButton() {
  const { open } = useApply();

  return (
    <motion.button
      initial={{ x: 60, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 0.6, type: "spring", stiffness: 200, damping: 24 }}
      onClick={open}
      data-testid="apply-fab"
      aria-label="Apply for admission"
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40 group hidden md:flex"
    >
      <span className="bg-brand-secondary text-brand-primary py-5 px-3 rounded-l-2xl shadow-[-8px_8px_24px_rgba(15,76,58,0.25)] flex flex-col items-center gap-3 hover:bg-brand-primary hover:text-brand-secondary transition-colors duration-300">
        <Sparkles className="w-4 h-4 group-hover:rotate-12 transition-transform" />
        <span
          className="font-semibold text-xs tracking-[0.3em] uppercase"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
        >
          Apply Now
        </span>
        <Sparkles className="w-4 h-4 group-hover:-rotate-12 transition-transform" />
      </span>
    </motion.button>
  );
}
